var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmployeeReg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 796.647,
    height: 762.257,
    viewBox: "0 0 796.647 762.257",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 57"
  }, /*#__PURE__*/React.createElement("image", {
    width: 34,
    height: 57,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAA5CAYAAABTVvmaAAAABHNCSVQICAgIfAhkiAAABRJJREFUWIXFmM9rVFcUx7/nvZk30ULEgAtXWRi7sGC2U2cUZqX9B1L/gNJ2Z23aWhcqVGp1YZtCoYUIKXSTLNtNdS0lZBO6iZukIAoWIraQdCQz95x7ush74c6b+36NMV4YLvcO887nfe/3nHfmASMOVf1QVc+M+vt9Gao6bq3dtNZuqOpbbxLktrVWVVVF5Oc3BTFprd2x1mryUdWLBw4iIovWWhURF+QfVT1+YBCq2hSRAQgH5v6BgVhrlxOIlCLJ/PFrh2Dmi4kaPpj485+qnnhtEKraEJHHIqLMnAkTK/OHqgZVY5T6ATNfBTAJAETkAg6tAZwB8EVVkMKhqpMispMokaVISpmeqp6uEqdQEWPMHVVtxFBeRTz7EYBf9q3q9vv9Zr/fV2bWiook809lY1Hel71eb5mImkQ0cMcASq1jpS4Q0YMikMyjefny5UVVbcYGTIw4EMS3dud4f0FVj44EEnvidnJRa236e1+2ZHnoOIAfRwLpdruXVXXShShSIL2fWr9f9GAc8sj29vYxVd0Iw3A88QYRIQh2mZPZly0F+/8CeIeI/vaBDClijLkJYDytRHrtpq47fPvx+iiAhQxBBkFevHhxCsAH1lqoqteA6f30nfv2HbjzqvpJIYiIfCsioRvQB5O601L7DswdX9XdA3n69OkFETmvqkgUGVUZd+3ZT6puNASyvr7eEJG7buA8iDwFSip1GsBXQyDW2ssickpEICJDiviMmiG7dz+tVPz95+r8HaHV1dVjY2NjG7VabTyKIoRhiCiKEAQBwjAcmNMp7Kaye8dl1vH8F4BpIuoGInKTmcettWBmJLPPK4kyviKXpUCeggBOALgLAIGIvCsiexDJ0YhIpeNJeaCKhz5S1fcCZr7GzHD9kcw+RVwD5xW5Ep2cu78QtNvt30TkQVmYvFROe6CCUn8GAMDMsyIiPpgsRYqKXslODkQkAD4NAKDdbq8x872yXslTJkuBLKWstT8Q0aPAobvOzFs+mDJ1pYoyzvp5EATXAKfEt1qtTRH5Jn08CVTZIuc2UUVeIaLrRLQ9AAIAvV5vTkQ2s7xStfwX1JFHAOaT2AMgnU5nh5lvJMeTpUxy5wlQTrBMZURkNjbqMAgAPHv2bN4Ys8bMA5XWZ9w8b2RBxePXer0+8PbA+3fi4cOHF6Io+r3RaCCKItTrddRqNSTPolqtBiLam8Mw9LaTvrZSVXthGL5NRE/cmN7m+ezZs/d9Rc53PFUVIaK5NEQmSBxkr8il60pVAzseeR4Ewde+eJkg7XZ7zRiTWeRcRco02vHYS9fSIABARNeNMVuucdOKuAbOgog/K0EQzGfFygVptVqbzDxU5NyKW1YZVb3kpmslEABg5jkReVz16ZyCWoqiaCUvTiFIp9PZMcZcTRe55FPigdgTkcI3SKVeXZ07d27RGLOcVXELYOYOHTo0lK4jgcRjtkonF0M8aTQa3nQdGaTVai0z85LveHJgrmSl68ggANDv979k5p2SrcLK4cOHF8teuxJIp9N5zMzfl+nkVPVSlWtXfjFbr9dvGWM282BUdenIkSO56frKIM1mc8taeyM5Hk9buU1ElV/4VgYBdnsWZl7LyKJbExMThem6LyAzMzNirf3MU1eedLvd70a55kggwG7PwswPUsdz5eTJk70DBQEAVZ1lZolhVqampkqn676CtNvtNRG5F8NUStf0qL3Kj4HdnsVauzU9PV0pXdPjf8goggKzEQX8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 69"
  }, /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 69,
    xlinkHref: "data:image/png;base64,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"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "employee-reg",
    transform: "translate(-922.121 -137.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    transform: "translate(1427.583 591.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5770",
    "data-name": "Path 5770",
    d: "M757.4,364.937a92.053,92.053,0,0,1-81.729,83.548c-41.826,4.706-96.552,62.9-162.286,14.408-53.131-39.2-34.229-57.614-28.712-161.648,5.669-106.883,143.732-141.921,187.181-74.971C725.784,309.372,762.843,303.629,757.4,364.937Z",
    transform: "translate(-466.748 -190.089)",
    fill: "#6a97fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5771",
    "data-name": "Path 5771",
    d: "M752.144,393.542a92.051,92.051,0,0,1-97.023,65.166C613.212,454.8,547.786,500.645,493.3,439.783c-44.04-49.192-21.786-63.374,4.79-164.108,27.3-103.493,169.608-109.7,198.521-35.306C732.5,332.706,769.948,334.625,752.144,393.542Z",
    transform: "translate(-468.289 -190.404)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.144
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5772",
    "data-name": "Path 5772",
    d: "M750.518,345.32A86.723,86.723,0,0,1,684.8,433.663c-38.45,9.687-82.173,70.946-149.678,33.992-54.562-29.868-39.248-49.451-47.266-147.27C479.614,219.885,604.065,169.7,653.1,226.7,713.967,297.45,747.835,287.4,750.518,345.32Z",
    transform: "translate(-464.848 -188.185)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.144
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5773",
    "data-name": "Path 5773",
    d: "M733.449,411.759a86.724,86.724,0,0,1-100.371,45.272C594.765,446.812,526.783,479.1,485.742,414c-33.171-52.618-10.27-62.291,30.258-151.681,41.639-91.838,174.8-75.221,189.953-1.573C724.767,352.16,759.251,359.833,733.449,411.759Z",
    transform: "translate(-468.011 -188.798)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.144
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_546",
    "data-name": "Ellipse 546",
    cx: 132.344,
    cy: 11.283,
    rx: 132.344,
    ry: 11.283,
    transform: "translate(14.287 286.018)",
    fill: "#130f40",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503",
    transform: "translate(45.488 6.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486",
    transform: "translate(143.867 98.849)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    "data-name": "Rectangle 1724",
    width: 41.975,
    height: 71.364,
    rx: 1.412,
    fill: "#7ed6df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    "data-name": "Rectangle 1725",
    width: 41.975,
    height: 8.917,
    transform: "translate(0 62.447)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    "data-name": "Rectangle 1726",
    width: 26.529,
    height: 5.191,
    transform: "translate(7.664 9.942)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1727",
    "data-name": "Rectangle 1727",
    width: 26.529,
    height: 5.191,
    transform: "translate(7.664 22.241)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    "data-name": "Rectangle 1728",
    width: 26.529,
    height: 5.191,
    transform: "translate(7.664 34.54)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_547",
    "data-name": "Ellipse 547",
    cx: 4.746,
    cy: 4.746,
    r: 4.746,
    transform: "translate(16.245 49.073)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5774",
    "data-name": "Path 5774",
    d: "M648.718,325.266a1.816,1.816,0,1,1-1.816-1.816A1.816,1.816,0,0,1,648.718,325.266Z",
    transform: "translate(-625.911 -271.448)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    transform: "translate(9.74 3.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5775",
    "data-name": "Path 5775",
    d: "M637.593,282.723h20.988c.675,0,.676-.659,0-.659H637.593c-.676,0-.677.659,0,.659Z",
    transform: "translate(-637.086 -282.064)",
    fill: "#dff9fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(4.751 66.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M633.522,336.417h30.792c.887,0,.888-.866,0-.866H633.522c-.887,0-.888.866,0,.866Z",
    transform: "translate(-632.857 -335.551)",
    fill: "#dff9fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    transform: "translate(38.485 5.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M662.218,336.7V284.285c0-.425-.761-.426-.761,0V336.7c0,.425.761.426.761,0Z",
    transform: "translate(-661.457 -283.967)",
    fill: "#dff9fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    transform: "translate(3.675 5.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M632.7,336.7V284.285c0-.425-.761-.426-.761,0V336.7c0,.425.761.426.761,0Z",
    transform: "translate(-631.944 -283.967)",
    fill: "#dff9fb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M521.043,461.33h-6.42l9.923-116.689h12.839Z",
    transform: "translate(-505.461 -168.796)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5780",
    "data-name": "Path 5780",
    d: "M676.106,461.33h6.42L672.6,344.641H659.764Z",
    transform: "translate(-479.409 -168.796)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    "data-name": "Rectangle 1729",
    width: 213.66,
    height: 7.015,
    transform: "translate(0 168.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    "data-name": "Rectangle 1730",
    width: 102.914,
    height: 55.994,
    transform: "translate(33.427 96.478)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 94.452,
    height: 48.482,
    transform: "translate(37.842 100.234)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    "data-name": "Rectangle 1732",
    width: 193.955,
    height: 5.061,
    transform: "translate(9.162 175.845)",
    fill: "#ffbe76"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 193.955,
    height: 2.531,
    transform: "translate(9.162 175.845)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488",
    transform: "translate(21.776 42.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1734",
    "data-name": "Rectangle 1734",
    width: 82.781,
    height: 7.108,
    transform: "translate(0 35.478)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(16.118 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1735",
    "data-name": "Rectangle 1735",
    width: 8.678,
    height: 34.337,
    transform: "translate(49.817 26.988) rotate(90)",
    fill: "#686de0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    "data-name": "Rectangle 1736",
    width: 8.678,
    height: 34.337,
    transform: "translate(18.418 9.632) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 8.678,
    height: 34.337,
    transform: "translate(15.48 18.31) rotate(-90)",
    fill: "#eb4d4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1738",
    "data-name": "Rectangle 1738",
    width: 8.678,
    height: 34.337,
    transform: "translate(20.901 26.988) rotate(-90)",
    fill: "#6ab04c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    width: 8.678,
    height: 34.337,
    transform: "translate(8.312 0) rotate(14.008)",
    fill: "#7ed6df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(115.792)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 82.781,
    height: 7.108,
    transform: "translate(0 56.295)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492",
    transform: "translate(1.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489",
    transform: "translate(12.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5781",
    "data-name": "Path 5781",
    d: "M628.015,229.751s-6.924-2.648-8.646-6.8,1.886-5.176,1.886-5.176-4.711-3.739-4.484-6.814a4.394,4.394,0,0,1,3.28-3.8s-7.147-5.491-.626-11.584c0,0,7.491-.655,7.582,6.15a4.561,4.561,0,0,1,5.7,1.31c2.354,3.063-1.247,10.429-1.247,10.429s2.464-2.028,4.653.044C638.846,216.091,635.625,225.755,628.015,229.751Z",
    transform: "translate(-616.681 -195.556)",
    fill: "#6ab04c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5782",
    "data-name": "Path 5782",
    d: "M619.223,195.939s10.88,17.863,8.336,33.743a73.669,73.669,0,0,1-3.435,13.587",
    transform: "translate(-616.224 -195.487)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5783",
    "data-name": "Path 5783",
    d: "M618.126,201.872l5.237,1.671,1.622-5.676",
    transform: "translate(-616.421 -195.141)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5784",
    "data-name": "Path 5784",
    d: "M618.64,203.662l5.612,1.965,1.541-5.765",
    transform: "translate(-616.329 -194.783)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5785",
    "data-name": "Path 5785",
    d: "M618.715,211.837l8.593,3.189,4.836-9.886",
    transform: "translate(-616.316 -193.835)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5786",
    "data-name": "Path 5786",
    d: "M619.062,218.214l8.878,5.055,7.382-11.252",
    transform: "translate(-616.253 -192.601)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5787",
    "data-name": "Path 5787",
    d: "M619.547,216.722l8.331,4.454,6.2-10.192",
    transform: "translate(-616.166 -192.786)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(0 12.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5788",
    "data-name": "Path 5788",
    d: "M623.3,230.137s-6.09-16.481-15.428-23.715c0,0-2.953,4.587-1.022,7.734s3.791,2.972,3.791,2.972-3.918,3.147-2.221,7.629,7.107,2.63,7.107,2.63-.892,1.749.2,2.92S619.631,232.479,623.3,230.137Z",
    transform: "translate(-606.195 -206.422)",
    fill: "#6ab04c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5789",
    "data-name": "Path 5789",
    d: "M607.617,206.422s9.818,8.246,15.428,23.715a34.492,34.492,0,0,1,1.516,9.949",
    transform: "translate(-605.94 -206.422)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    x2: 5.854,
    y2: 0.503,
    transform: "translate(2.54 6.998)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    x2: 9.899,
    y2: 1.424,
    transform: "translate(3.647 14.408)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    x2: 11.392,
    y2: 1.431,
    transform: "translate(3.715 17.419)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    x2: 5.828,
    y2: 0.732,
    transform: "translate(11.019 22.288)",
    fill: "none",
    stroke: "#badc58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.34
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5790",
    "data-name": "Path 5790",
    d: "M632.984,245.745H617.649l-2.235-16.174h19.8Z",
    transform: "translate(-604.541 -189.45)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5791",
    "data-name": "Path 5791",
    d: "M617.011,241.122l.352,2.549H632.7l.352-2.549Z",
    transform: "translate(-604.254 -187.377)",
    fill: "#eb4d4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(37.407 11.913)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 34.022,
    height: 44.382,
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742",
    "data-name": "Rectangle 1742",
    width: 28.921,
    height: 38.712,
    transform: "translate(2.55 3.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743",
    "data-name": "Rectangle 1743",
    width: 19.658,
    height: 26.313,
    transform: "translate(7.218 9.795)",
    fill: "#fc443e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499",
    transform: "translate(47.655 86.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5792",
    "data-name": "Path 5792",
    d: "M553.962,322.881s-7.483,16.43-4.126,18.743,10.3,1.417,13.839-6.168a127.163,127.163,0,0,0,5.183-12.576Z",
    transform: "translate(-546.951 -258.777)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5793",
    "data-name": "Path 5793",
    d: "M611.689,322.881s7.484,16.43,4.126,18.743-10.3,1.417-13.838-6.168a126.823,126.823,0,0,1-5.183-12.576Z",
    transform: "translate(-538.367 -258.777)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(66.248 180.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5794",
    "data-name": "Path 5794",
    d: "M612.015,431.832l-.756-10.51-7.834.579,1.886,10.117Z",
    transform: "translate(-603.425 -421.322)",
    fill: "#ffc2bd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5795",
    "data-name": "Path 5795",
    d: "M606.177,427.156c3.587-1.642,6.967,1.279,7.919,6.57s7.252,8.913,3.655,10.277c-6.848,2.6-14.257.14-13.338-4.808C605.663,432.476,601.7,429.2,606.177,427.156Z",
    transform: "translate(-537.077 -240.142)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5796",
    "data-name": "Path 5796",
    d: "M610.325,367.727c-.132,1.208,4.677,32.776,4.79,42.489s-.3,23.823-.3,23.823a17.276,17.276,0,0,0-9.083.934,210.762,210.762,0,0,1-7.8-23.122c-3.961-14.464-9.1-31.625-9.7-36.155Z",
    transform: "translate(-539.904 -250.727)",
    fill: "#22a6b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497",
    transform: "translate(6.935 180.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5797",
    "data-name": "Path 5797",
    d: "M553.138,432.035l.756-10.51,7.834.579-1.886,10.117Z",
    transform: "translate(-553.138 -421.525)",
    fill: "#ffc2bd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5798",
    "data-name": "Path 5798",
    d: "M559.932,427.36c-3.588-1.642-6.967,1.277-7.919,6.57s-7.252,8.913-3.655,10.277c6.848,2.6,14.255.14,13.337-4.809C560.446,432.678,564.405,429.406,559.932,427.36Z",
    transform: "translate(-547.258 -240.106)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5799",
    "data-name": "Path 5799",
    d: "M557.616,367.93c.131,1.207-4.677,32.776-4.79,42.489s.3,23.823.3,23.823a17.275,17.275,0,0,1,9.083.934,210.9,210.9,0,0,0,7.8-23.122c3.962-14.465,9.1-31.626,9.7-36.156Z",
    transform: "translate(-546.263 -250.691)",
    fill: "#22a6b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(8.822 110.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5800",
    "data-name": "Path 5800",
    d: "M558.954,362.554s-9.486,6.868,0,15.988h53.609s8.253-6.321.707-15.988Z",
    transform: "translate(-554.738 -362.554)",
    fill: "#7ed6df"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5801",
    "data-name": "Path 5801",
    d: "M608.235,337.114c9.324,2.363,16.117-5.409,16.117-5.409-1.42-7.893-10.153-23.858-10.153-23.858h-.026s-6.777-6.313-27.158-6.313-27.158,6.313-27.158,6.313-8.732,15.964-10.153,23.858c0,0,6.781,7.759,16.092,5.415.954,5.229,1.746,10.067,2.1,13.405,1.263,11.869-8.039,22.981-8.039,22.981C562.53,379.819,574.773,384,587.015,384s24.485-4.179,27.158-10.492c0,0-9.3-11.112-8.039-22.981C606.488,347.185,607.281,342.345,608.235,337.114Z",
    transform: "translate(-546.819 -262.608)",
    fill: "#ffbe76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5802",
    "data-name": "Path 5802",
    d: "M611.8,330.347c-2.174-.69-2.442-9.193-5.2-16.161-.823,8.686,2,13.784-5.074,17.322-14.154,8.256-33.854,6.006-34.789-17.744-2.578,7.391.1,15.882-2.924,16.584-3.517-.879-11.318-.836-12.227-7.1a37.912,37.912,0,0,0-1.882,6.265s6.781,7.759,16.092,5.415c.954,5.229,1.746,10.067,2.1,13.4,1.263,11.869-8.039,22.981-8.039,22.981,2.673,6.313,14.916,10.492,27.158,10.492s24.485-4.179,27.158-10.492c0,0-9.3-11.112-8.039-22.981.355-3.34,1.148-8.18,2.1-13.411,9.324,2.363,16.117-5.409,16.117-5.409a29.206,29.206,0,0,0-1-3.767C621.188,327.384,613.975,331.036,611.8,330.347Z",
    transform: "translate(-546.819 -260.414)",
    fill: "#130f40",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5803",
    "data-name": "Path 5803",
    d: "M603.882,307.351c.753.431,1.481,2.555.791,2.759s-8.432-4.394-8.495-5.108S602.452,306.533,603.882,307.351Z",
    transform: "translate(-538.477 -262.011)",
    fill: "#fcfffd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5804",
    "data-name": "Path 5804",
    d: "M560.16,307.351c-.753.431-1.481,2.555-.791,2.759s8.432-4.394,8.495-5.108S561.59,306.533,560.16,307.351Z",
    transform: "translate(-545.134 -262.011)",
    fill: "#fcfffd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5805",
    "data-name": "Path 5805",
    d: "M565.545,335.53s-.887-32.114-1.355-43.565c-.479-11.657,2.925-25.6,17.624-22.892,13.485-3.615,18.407,11.653,18.5,22.892.1,11.451,1.614,44.616,1.614,44.616h-5.254l-.823-8.022-1.214,6.587-15.194.948-.365-8.143-1.6,7.525-4.967.618-.972-23.822-1.026,23.822Z",
    transform: "translate(-544.227 -268.532)",
    fill: "#eb4d4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5806",
    "data-name": "Path 5806",
    d: "M580.561,271.607c.574,1.4-2.992,1.759-6.216,3.08s-4.883,3.108-5.458,1.706,1.572-3.612,4.795-4.933S579.985,270.2,580.561,271.607Z",
    transform: "translate(-543.393 -268.177)",
    fill: "#fcfffd",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(45.943 155.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    transform: "translate(8.722)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    "data-name": "Rectangle 1744",
    width: 6.6,
    height: 49.918,
    transform: "translate(30.576 76.98)",
    fill: "#fde58a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745",
    "data-name": "Rectangle 1745",
    width: 6.6,
    height: 49.918,
    transform: "translate(30.576 76.98)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    width: 14.874,
    height: 9.092,
    transform: "translate(26.439 72.435)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    "data-name": "Rectangle 1747",
    width: 34.266,
    height: 8.566,
    transform: "translate(16.743 63.868)",
    fill: "#ffbe76"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 34.266,
    height: 8.566,
    transform: "translate(16.743 63.868)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5807",
    "data-name": "Path 5807",
    d: "M601.862,368.012H570.1a7.222,7.222,0,0,1-7.118-6l-4.558-26.451a7.223,7.223,0,0,1,7.117-8.45H606.42a7.223,7.223,0,0,1,7.118,8.45l-4.557,26.451A7.223,7.223,0,0,1,601.862,368.012Z",
    transform: "translate(-552.285 -327.114)",
    fill: "#686de0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5808",
    "data-name": "Path 5808",
    d: "M598.668,367.053H571.951a6.085,6.085,0,0,1-5.986-5.072L562.132,339.6a6.1,6.1,0,0,1,5.986-7.148H602.5a6.1,6.1,0,0,1,5.986,7.148l-3.832,22.377A6.085,6.085,0,0,1,598.668,367.053Z",
    transform: "translate(-551.615 -326.155)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5809",
    "data-name": "Path 5809",
    d: "M615.01,385.228H557.764a4.56,4.56,0,0,1-4.382-5.821h0a4.56,4.56,0,0,1,4.382-3.3H615.01a4.56,4.56,0,0,1,4.382,3.3h0A4.56,4.56,0,0,1,615.01,385.228Z",
    transform: "translate(-553.202 -318.32)",
    fill: "#686de0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5810",
    "data-name": "Path 5810",
    d: "M614.977,379.464H557.731c-2,0-3.751.814-4.345,2,.58,1.125,2.263,1.982,4.345,1.982h57.245c2.082,0,3.765-.856,4.345-1.982C618.729,380.278,616.975,379.464,614.977,379.464Z",
    transform: "translate(-553.169 -317.718)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    "data-name": "Rectangle 1749",
    width: 23.488,
    height: 9.937,
    rx: 2.577,
    transform: "translate(21.95 15.797)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    "data-name": "Rectangle 1750",
    width: 9.119,
    height: 51.986,
    transform: "translate(29.178 20.449)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5811",
    "data-name": "Path 5811",
    d: "M584.476,436l-35.161,4.627V436l35.161-8.514Z",
    transform: "translate(-545.177 -309.098)",
    fill: "#ffbe76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5812",
    "data-name": "Path 5812",
    d: "M584.721,436l35.161,4.627V436l-35.161-8.514Z",
    transform: "translate(-538.822 -309.098)",
    fill: "#ffbe76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5813",
    "data-name": "Path 5813",
    d: "M554.082,440.694a4.138,4.138,0,1,1-4.138-4.138A4.137,4.137,0,0,1,554.082,440.694Z",
    transform: "translate(-545.807 -307.47)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5814",
    "data-name": "Path 5814",
    d: "M619.3,440.694a4.138,4.138,0,1,1-4.138-4.138A4.138,4.138,0,0,1,619.3,440.694Z",
    transform: "translate(-534.101 -307.47)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501",
    transform: "translate(38.655 118.385)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    width: 3.052,
    height: 8.275,
    transform: "translate(0 9.855)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1752",
    "data-name": "Rectangle 1752",
    width: 3.052,
    height: 8.275,
    transform: "translate(4.835 9.855)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1753",
    "data-name": "Rectangle 1753",
    width: 1.783,
    height: 5.812,
    transform: "translate(3.052 11.035)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5815",
    "data-name": "Path 5815",
    d: "M584.144,440.624h-3.438l-1.581-13.141h6.6Z",
    transform: "translate(-578.481 -427.484)",
    fill: "#ffbe76"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2550",
    "data-name": "Group 2550",
    transform: "translate(1294.464 137.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2534",
    "data-name": "Group 2534",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M280.81,110.382C348.988,40.54,430.989,41,505.124,84.039c33.141,19.237,40.238,48.457,45.349,80.8,6.321,40.009,36.5,62.76-1.2,101.381-27.6,28.275-71.537,45.025-107.819,41.986-57.361-4.8-105.738,32.167-149.862,6.555-33.481-19.435,1.333-57-14.028-86.028C242.553,162.557,243.422,148.682,280.81,110.382Z",
    transform: "translate(-250.355 -54.32)",
    fill: "#fa616e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M301.074,97.874c75.378-61.144,151.766-51.495,213.627-.8,27.655,22.66,29.336,52.234,28.637,84.661-.866,40.112,23.437,65.9-18.244,99.712C494.58,306.2,450.777,317.77,417.456,310.71c-52.677-11.16-104.036,19.829-140.855-10.342-27.937-22.894,10.873-55.985,1.454-86.3C256.583,144.971,259.739,131.4,301.074,97.874Z",
    transform: "translate(-247.029 -54.025)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M273.984,121.177c57.342-71.951,134.654-74.106,213.524-40.469,35.258,15.036,46.293,41.857,55.808,71.8,11.771,37.038,44.608,55.651,12.9,95.436C533,277.07,492.124,296.866,456.027,297.352c-57.068.767-99.5,39.984-146.445,19.964-35.62-15.19-6.6-53.714-25.737-79.6C240.228,178.72,242.539,160.633,273.984,121.177Z",
    transform: "translate(-250.695 -52.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M289.4,107.739C358.828,42.233,437.347,45.9,505.817,90.809c30.608,20.076,35.681,48.878,38.667,80.651,3.692,39.3,31.261,62.695-7.131,98.918C509.247,296.9,466.172,311.527,431.6,307.14c-54.66-6.936-103.182,27.259-143.934.528-30.922-20.282,4.642-55.584-8.357-84.525C249.673,157.172,251.326,143.661,289.4,107.739Z",
    transform: "translate(-248.621 -53.448)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.082
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_549",
    "data-name": "Ellipse 549",
    cx: 123.865,
    cy: 14.632,
    rx: 123.865,
    ry: 14.632,
    transform: "translate(15.631 261.633)",
    fill: "#130f40",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2549",
    "data-name": "Group 2549",
    transform: "translate(19.108 34.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2535",
    "data-name": "Group 2535",
    transform: "translate(29.339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    "data-name": "Rectangle 1761",
    width: 174.393,
    height: 7.84,
    transform: "translate(0 107.486)",
    fill: "#130f40",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    "data-name": "Rectangle 1762",
    width: 174.393,
    height: 108.756,
    fill: "#eb4d4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 157.448,
    height: 92.742,
    transform: "translate(8.472 8.007)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 9.483,
    height: 92.742,
    transform: "translate(82.455 8.007)",
    fill: "#eb4d4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2544",
    "data-name": "Group 2544",
    transform: "translate(0 84.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5878",
    "data-name": "Path 5878",
    d: "M433.065,191.319c-24.2-2.785-39.615,1.057-45.77-1.082-11.2-3.893-34.925-.332-38.169,1.165s-7.15,19.687-7.15,19.687l4.388-.882s7.828-8.34,9.632-10.831a3.647,3.647,0,0,0,.778-2.131c0-1.88,24.793,6.221,30.487,4.174,0,0,35.549,8.788,47.545,6.231Z",
    transform: "translate(-246.367 -138.949)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5879",
    "data-name": "Path 5879",
    d: "M433.584,207.489c.43-.059.838-.128,1.222-.21l-1.741-16.33c-5.883-.677-11.237-.958-16.074-1.033l1.127,9.446c-20.069-2.223-43.271-6.02-62.374-6.02-2.5,0-4.137,3.978-9.164,10.261,0,.637-1.292.627-2.893.136-1.029,3.805-1.712,6.98-1.712,6.98l4.388-.882s7.828-8.34,9.632-10.831a3.647,3.647,0,0,0,.778-2.131c0-1.88,24.793,6.221,30.487,4.174,0,0,25.7,6.352,40.77,6.68A29.388,29.388,0,0,0,433.584,207.489Z",
    transform: "translate(-246.367 -138.579)",
    fill: "#ff4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5880",
    "data-name": "Path 5880",
    d: "M432.6,188.85H404.29l2.522,21.672h30.869s10.847,0,8.307-10.837S432.6,188.85,432.6,188.85Z",
    transform: "translate(-230.369 -138.852)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M443.887,199.686C441.346,188.85,430.5,188.85,430.5,188.85H415.983a19.094,19.094,0,0,1,1.064,2.385c2.648,7.416.579,14.694-4.573,19.287H435.58S446.427,210.522,443.887,199.686Z",
    transform: "translate(-228.268 -138.852)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1765",
    "data-name": "Rectangle 1765",
    width: 13.404,
    height: 17.003,
    transform: "matrix(0.135, 0.991, -0.991, 0.135, 44.699, 140.905)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1766",
    "data-name": "Rectangle 1766",
    width: 4.426,
    height: 17.003,
    transform: "matrix(0.135, 0.991, -0.991, 0.135, 45.912, 149.801)",
    fill: "#ff4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5882",
    "data-name": "Path 5882",
    d: "M296.728,275.551l62.726-14.96,47.79.141L391,226.1l-11.742,34.548-19.807-.058s9.854-65.961,27.212-67.688,53.488,61.686,53.488,61.686L472.7,282.8c-7.476,18.406-85.912,5.88-109.112,7.6-29.806,2.209-63.081,7.9-63.081,7.9Z",
    transform: "translate(-257.984 -137.821)",
    fill: "#22a6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M440.154,254.589s-36.13-63.413-53.488-61.685-27.212,67.688-27.212,67.688l19.807.058L391,226.1l16.241,34.631-47.79-.141s-4.243,5.9,7.382,10.317,33.605,6.022,33.171,9.476-25.339,1.994-33.228,2.517-57.365,6.45-59.043,5.413c-2.479-1.532-2.716-10.049-3.54-14.544l-7.469,1.782,3.779,22.753s33.275-5.693,63.081-7.9c23.2-1.72,101.636,10.805,109.112-7.6Z",
    transform: "translate(-257.984 -137.821)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5884",
    "data-name": "Path 5884",
    d: "M446.7,288.809s38.138-58.849,17.04-93.706c-4.381-7.238-14.064-11.529-20.314-11.98-12.32-.887-18.629,7.136-18.629,17.259,0,14.408-7.4,46.784-17.291,49.645C407.511,250.026,412.143,278.364,446.7,288.809Z",
    transform: "translate(-229.542 -140.34)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5885",
    "data-name": "Path 5885",
    d: "M462.661,238.842c-5.222,10.937-18.189,28.474-32.425,22.088-8.978-4.027-13.883-14.435-16.336-24.574-1.958,3.222-4.106,5.468-6.389,6.129,0,0,4.632,28.338,39.194,38.783,0,0,23.555-36.355,23.4-68.841A84.735,84.735,0,0,1,462.661,238.842Z",
    transform: "translate(-229.542 -132.8)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541",
    transform: "translate(176.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5886",
    "data-name": "Path 5886",
    d: "M421.27,180.682l8.607,18.821s9.864,2.15,11.752-4.11l-4.213-30.867Z",
    transform: "translate(-402.453 -145.097)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5887",
    "data-name": "Path 5887",
    d: "M440.545,187.446l-3.128-22.919L421.27,180.682l8.327,18.206A47.944,47.944,0,0,0,440.545,187.446Z",
    transform: "translate(-402.453 -145.097)",
    fill: "#ff4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5888",
    "data-name": "Path 5888",
    d: "M410.678,178.346c1.609,12.253,3.562,20.519,9.643,21.568s14.344-5.41,18.946-12.218c12.383-18.319,3.211-31.369-3.773-34.466C418.364,145.634,409.07,166.092,410.678,178.346Z",
    transform: "translate(-405.219 -148.42)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5889",
    "data-name": "Path 5889",
    d: "M435.5,167.087c4.757,1.743-1.955,8.683,6.246,8.683,3.079-12.236-.95-20.11-6.379-22.518-13.863-6.148-22.38,4.98-24.354,16.363C422.763,174.789,430.738,165.343,435.5,167.087Z",
    transform: "translate(-405.088 -148.442)",
    fill: "#ff4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5890",
    "data-name": "Path 5890",
    d: "M419.681,188.12c7.382.794,15.621,3.319,17.935-5.548s3.1-17.481-1.346-18.715-11.746,6.644-19.711,4.979-13.4-7.054-8.243-13.355,11.387-3.6,11.387-3.6,14.731-6.579,24.21.371,6.463,25.978-.464,34.994-9.49,16.472-21.674,16.049C409.141,202.858,412.3,187.327,419.681,188.12Z",
    transform: "translate(-406.297 -149.066)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5891",
    "data-name": "Path 5891",
    d: "M432.949,151.678c.065.977-2.572,1.948-5.892,2.17s-6.063-.387-6.128-1.364,2.573-1.947,5.892-2.169S432.883,150.7,432.949,151.678Z",
    transform: "translate(-402.541 -148.757)",
    fill: "#686de0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5892",
    "data-name": "Path 5892",
    d: "M416.393,153.194c.7,1-.509,3.049-2.7,4.577s-4.527,1.957-5.224.956.508-3.049,2.694-4.577S415.695,152.2,416.393,153.194Z",
    transform: "translate(-405.789 -148.145)",
    fill: "#686de0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5893",
    "data-name": "Path 5893",
    d: "M433.929,168.313s3.838-5.445,6.533.073c1.795,3.676-.875,12.838-7.447,10.812Z",
    transform: "translate(-399.438 -144.741)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2540",
    "data-name": "Group 2540",
    transform: "translate(5.096 23.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2537",
    "data-name": "Group 2537",
    transform: "translate(1.731 4.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2536",
    "data-name": "Group 2536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5894",
    "data-name": "Path 5894",
    d: "M423.419,171.71a2.111,2.111,0,1,1-1.555,2.1A1.876,1.876,0,0,1,423.419,171.71Z",
    transform: "translate(-409.128 -171.709)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5895",
    "data-name": "Path 5895",
    d: "M413.286,171.873a2.112,2.112,0,1,1-1.555,2.1A1.878,1.878,0,0,1,413.286,171.873Z",
    transform: "translate(-411.73 -171.668)",
    fill: "#130f40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2538",
    "data-name": "Group 2538",
    transform: "translate(7.188 7.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5896",
    "data-name": "Path 5896",
    d: "M418.416,180.874a2.473,2.473,0,0,0,.67-.235.255.255,0,1,0-.235-.452,1.821,1.821,0,0,1-1.806-.036.954.954,0,0,1-.459-.886,6.772,6.772,0,0,1,.74-1.766c.687-1.351,1.468-2.883,1.039-3.922a.255.255,0,0,0-.471.195c.339.822-.416,2.3-1.023,3.495a6.69,6.69,0,0,0-.794,1.955,1.457,1.457,0,0,0,.684,1.354A2.232,2.232,0,0,0,418.416,180.874Z",
    transform: "translate(-416.072 -173.419)",
    fill: "#262743"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2539",
    "data-name": "Group 2539",
    transform: "translate(11.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5897",
    "data-name": "Path 5897",
    d: "M419.822,169.559A.881.881,0,0,1,420.2,169c2.491-1.629,5.492-1.606,8.92.062a.883.883,0,0,1-.377,1.676.9.9,0,0,1-.4-.089c-2.869-1.4-5.219-1.453-7.182-.172a.882.882,0,0,1-1.347-.919Z",
    transform: "translate(-419.803 -167.796)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5898",
    "data-name": "Path 5898",
    d: "M415.442,170.475a.87.87,0,0,0,.663.127.879.879,0,0,0,.559-.382.884.884,0,0,0-.256-1.222,7.508,7.508,0,0,0-5.658-1.037,1.534,1.534,0,0,0-.161,1.83A5.921,5.921,0,0,1,415.442,170.475Z",
    transform: "translate(-410.352 -167.793)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5899",
    "data-name": "Path 5899",
    d: "M416.8,178.247c.01.323.461.572,1.007.554s.979-.293.969-.616-.461-.572-1.007-.554S416.79,177.924,416.8,178.247Z",
    transform: "translate(-408.697 -165.271)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5900",
    "data-name": "Path 5900",
    d: "M437,169.139c-.9-.151-1.829.951-2.085,2.463s.264,2.859,1.16,3.011,1.829-.951,2.085-2.463S437.9,169.291,437,169.139Z",
    transform: "translate(-404.063 -167.454)",
    fill: "#ff4c4a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5901",
    "data-name": "Path 5901",
    d: "M297.3,264.5l.987,15.885s-7.8,7.38-13.791,6.526-18.6-29.527-18.6-33.552,4.969-5.67,8.966-.266S287.761,267.769,297.3,264.5Z",
    transform: "translate(-265.899 -123.241)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5902",
    "data-name": "Path 5902",
    d: "M288.448,275.487c2.251-.75,2.939-5.14,3.152-9.565-7.229.654-13.706-6.187-16.791-10.357-1.654-2.237-3.5-3.06-4.97-2.94C273.9,262.423,278.349,276.5,288.448,275.487Z",
    transform: "translate(-264.888 -122.482)",
    fill: "#fcfffd",
    opacity: 0.15
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548",
    transform: "translate(84.882 149.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2547",
    "data-name": "Group 2547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545",
    transform: "translate(0.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5903",
    "data-name": "Path 5903",
    d: "M339.751,200.8l24.153,3.911a1.74,1.74,0,0,1,1.239.87l31.381,56.261a1.736,1.736,0,0,1-1.734,2.569l-26.675-3.383a1.717,1.717,0,0,1-1.34-.958c-3.009-6.227-27.238-43.982-33.022-55.286C333.105,203.517,338.346,200.572,339.751,200.8Z",
    transform: "translate(-333.697 -200.787)",
    fill: "#7ed6df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2546",
    "data-name": "Group 2546",
    transform: "translate(0 2.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5904",
    "data-name": "Path 5904",
    d: "M335.463,202.88l24.154,3.912a1.735,1.735,0,0,1,1.239.868l31.381,56.263a1.737,1.737,0,0,1-1.734,2.569l-26.675-3.384a1.713,1.713,0,0,1-1.34-.956c-3.009-6.227-23.071-45.472-28.853-56.777A1.732,1.732,0,0,1,335.463,202.88Z",
    transform: "translate(-333.441 -202.856)",
    fill: "#dff9fb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5905",
    "data-name": "Path 5905",
    d: "M432.955,249.632l-52.437.613a2.327,2.327,0,0,0-2.285,2.588h0a2.326,2.326,0,0,0,2.329,2.066L433,254.518a2.328,2.328,0,0,0,2.31-2.31v-.233A2.327,2.327,0,0,0,432.955,249.632Z",
    transform: "translate(-321.945 -188.247)",
    fill: "#7ed6df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5906",
    "data-name": "Path 5906",
    d: "M389.3,260.405l6.566-7.028,14.8,1.139s29.511-8.864,32.257-12.031,9.059-31.726,9.059-31.726l16.444-.917s-6.069,38.927-9.236,41.952-26.7,8.025-26.7,8.025Z",
    transform: "translate(-319.101 -198.462)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5907",
    "data-name": "Path 5907",
    d: "M390.686,249.048l-1.391,1.489,43.188-.584s1.661-.29,7.176-1.674Z",
    transform: "translate(-319.101 -188.594)",
    fill: "#ff4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5908",
    "data-name": "Path 5908",
    d: "M451.751,238.5c2.316-11.541,5.075-28.66,5.075-28.66l-16.444.917s-3.113,14.083-5.918,23.568Z",
    transform: "translate(-307.505 -198.462)",
    fill: "#ff4c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5909",
    "data-name": "Path 5909",
    d: "M357.557,230.122c.857,2.3.505,4.551-.787,5.032s-3.031-.992-3.888-3.289-.505-4.551.787-5.032S356.7,227.825,357.557,230.122Z",
    transform: "translate(-328.57 -194.123)",
    fill: "#7ed6df"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5910",
    "data-name": "Path 5910",
    d: "M455.592,238.873l-21.985-4,5.51-30.284A11.175,11.175,0,0,1,452.11,195.6h0a11.173,11.173,0,0,1,8.992,12.993Z",
    transform: "translate(-222.843 -52.378)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5911",
    "data-name": "Path 5911",
    d: "M449.929,195.6h0a11.12,11.12,0,0,0-7.827,1.474,6.453,6.453,0,0,1,3.852.63c6.677,3.231,6.228,13.421,5.836,19.491-.478,7.378.177,16.477-6.7,20.168l8.317,1.513,5.51-30.282A11.173,11.173,0,0,0,449.929,195.6Z",
    transform: "translate(-220.662 -52.378)",
    fill: "#130f40",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2533",
    "data-name": "Group 2533",
    transform: "translate(922.121 468.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505",
    transform: "translate(0 9.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5816",
    "data-name": "Path 5816",
    d: "M345.706,376.54c0,96.16-61.825,137.583-148.909,137.583-38.929,0-65.638-22.057-93.143-47.876C69.63,434.31,30.346,429.713,30.346,376.54c0-38.928,20.683-76.063,50.113-91.9,46.525-25.04,55.737-82.21,107.567-82.21,39.33,0,40.718,50.77,73.485,68.447C336.2,311.17,345.706,323.809,345.706,376.54Z",
    transform: "translate(-30.346 -202.429)",
    fill: "#ffeb84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5817",
    "data-name": "Path 5817",
    d: "M336.219,398.122c-11.765,92.186-76.1,122.675-159.59,109.684C139.308,502,116.4,476.868,93.192,448.012c-28.711-35.692-65.81-45.959-59.3-96.936,4.764-37.321,29.136-69.835,59.286-80.629,47.666-17.065,63.494-70.5,113.183-62.767,37.7,5.866,32.824,54.746,62.074,76.581C335.106,334.035,342.671,347.568,336.219,398.122Z",
    transform: "translate(-29.609 -201.242)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.093
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5818",
    "data-name": "Path 5818",
    d: "M340.737,361.1c9.668,92.483-46.723,133.816-130.479,144.492-37.441,4.773-65.346-13.168-94.4-34.629-35.934-26.544-74.179-26.15-79.524-77.29-3.914-37.44,12.246-75.691,38.957-94.531,42.229-29.786,45.343-85.9,95.191-92.254,37.825-4.821,44.265,43.838,77.556,56.823C323.93,293.306,335.435,310.38,340.737,361.1Z",
    transform: "translate(-28.916 -201.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.093
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5819",
    "data-name": "Path 5819",
    d: "M338.454,382.475c-4.111,92.987-65.667,129.821-149.878,125.282C150.932,505.727,126.047,483,100.552,456.6,69.016,423.947,31.225,417.455,33.5,366.035c1.665-37.643,23.253-72.475,52.388-86.256,46.061-21.789,57.414-76.592,107.534-73.891,38.031,2.049,37.2,51.218,68.133,70.02C332.058,318.766,340.708,331.483,338.454,382.475Z",
    transform: "translate(-29.539 -201.54)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.093
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2532",
    "data-name": "Group 2532",
    transform: "translate(41.168 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2524",
    "data-name": "Group 2524",
    transform: "translate(0 80.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5820",
    "data-name": "Path 5820",
    d: "M62.951,427.351c1.568-2.889,96.312-18.31,110.978-15.1s51.781,17.985,51.688,21.527-111.349,19.7-116.212,18.371S61.384,430.24,62.951,427.351Z",
    transform: "translate(-62.909 -218.55)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508",
    transform: "translate(0.042 56.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    transform: "translate(12.499 99.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5821",
    "data-name": "Path 5821",
    d: "M108.925,455.17a2.513,2.513,0,0,1-2.475-2.1L96.66,393.939,77.652,438.419a2.512,2.512,0,0,1-4.621-1.974l22.391-52.393a2.512,2.512,0,0,1,4.788.577l11.195,67.619a2.51,2.51,0,0,1-2.068,2.888A2.413,2.413,0,0,1,108.925,455.17Z",
    transform: "translate(-72.829 -382.527)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507",
    transform: "translate(105.644 99.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5822",
    "data-name": "Path 5822",
    d: "M191.9,442.179a2.511,2.511,0,0,1-2.374-1.69l-18.3-52.938h-9.181l-10.6,41.492a2.512,2.512,0,1,1-4.867-1.245l11.079-43.38a2.514,2.514,0,0,1,2.434-1.89h12.922a2.512,2.512,0,0,1,2.374,1.692l18.887,54.629a2.512,2.512,0,0,1-1.554,3.195A2.485,2.485,0,0,1,191.9,442.179Z",
    transform: "translate(-146.505 -382.526)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5823",
    "data-name": "Path 5823",
    d: "M105.718,421.711c43.439,7.94,103-17.812,101.654-21.729s-34.034,10.229-44.781-13.636,5.822-90.59-59.559-82.082S62.281,413.771,105.718,421.711Z",
    transform: "translate(-62.942 -303.519)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2523",
    "data-name": "Group 2523",
    transform: "translate(15.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5824",
    "data-name": "Path 5824",
    d: "M106.978,269.455s1.426,41.3,5.564,43.369,15.342,2.731,22.064-3.109c0,0-4.062-3.166-4.676-13.209s-2.19-26.436-2.19-26.436Z",
    transform: "translate(-66.317 -256.168)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5825",
    "data-name": "Path 5825",
    d: "M147.1,326.614,129.43,311.621l-6.929-.905-3.608-17.329-12.775-4.458s3.877,20.262-7.3,25.707l-15.6,19.751a78.36,78.36,0,0,1,15.252,13.63.711.711,0,0,1,.062.107l35.158-8.444,22.921,34.033,7.108-.884Z",
    transform: "translate(-72.595 -251.022)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5826",
    "data-name": "Path 5826",
    d: "M126.352,337.605l5.359,7.956s4-2.635,3.931-10.01,3.353-7.883,3.353-7.883l-2.9-8.067C130.4,324.052,127.908,330.681,126.352,337.605Z",
    transform: "translate(-61.197 -242.917)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5827",
    "data-name": "Path 5827",
    d: "M101.878,299.642a49.637,49.637,0,0,0,14.056,2.526l-1.828-8.782-12.775-4.458A46.329,46.329,0,0,1,101.878,299.642Z",
    transform: "translate(-67.809 -251.022)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2516",
    "data-name": "Group 2516",
    transform: "translate(17.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5828",
    "data-name": "Path 5828",
    d: "M97.492,275.777c-4.661,15.131,6.042,30.744,21.873,31,.2,0,.406.005.611.005,3.218,0,8.422-10.739,9.066-20.007,1.027-14.773-2.767-24.98-14.593-24.98C104.342,261.8,99.652,268.764,97.492,275.777Z",
    transform: "translate(-86.323 -258.192)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5829",
    "data-name": "Path 5829",
    d: "M114.448,261.8c-10.106,0-14.8,6.966-16.956,13.979A24.051,24.051,0,0,0,108.181,303.7c-2.951-5.613-2.309-12.89-2.1-17.731,7.537-.611,13.906-1.678,20.027-7.9a10.833,10.833,0,0,0,3.025,1.989C128.629,269.011,124.377,261.8,114.448,261.8Z",
    transform: "translate(-86.322 -258.192)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    "data-name": "Group 2515",
    transform: "translate(21.025 24.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510",
    transform: "translate(2.101 4.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5830",
    "data-name": "Path 5830",
    d: "M109.163,281.824a1.9,1.9,0,1,0,1.456,1.847A1.689,1.689,0,0,0,109.163,281.824Z",
    transform: "translate(-106.46 -281.824)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5831",
    "data-name": "Path 5831",
    d: "M119.051,281.824a1.9,1.9,0,1,0,1.456,1.847A1.689,1.689,0,0,0,119.051,281.824Z",
    transform: "translate(-103.847 -281.824)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5832",
    "data-name": "Path 5832",
    d: "M108.274,282.839c-.8-.085-1.2-.755-1.5-.554s.869,1.507,1.5,1.608S108.274,282.839,108.274,282.839Z",
    transform: "translate(-106.72 -281.712)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5833",
    "data-name": "Path 5833",
    d: "M119.652,282.839c.8-.085,1.2-.755,1.506-.554s-.869,1.507-1.506,1.608S119.652,282.839,119.652,282.839Z",
    transform: "translate(-103.377 -281.712)",
    fill: "#130f40"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511",
    transform: "translate(10.814 6.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5834",
    "data-name": "Path 5834",
    d: "M114.351,289.995a2.277,2.277,0,0,1-.609-.192.229.229,0,0,1,.2-.413,1.642,1.642,0,0,0,1.623-.083.859.859,0,0,0,.387-.809,6.1,6.1,0,0,0-.716-1.568c-.656-1.195-1.4-2.549-1.046-3.5a.233.233,0,0,1,.3-.134.23.23,0,0,1,.134.3c-.282.748.439,2.059,1.018,3.113a6.074,6.074,0,0,1,.77,1.736,1.313,1.313,0,0,1-.576,1.236A2,2,0,0,1,114.351,289.995Z",
    transform: "translate(-113.611 -283.285)",
    fill: "#eb4d4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(0 0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5835",
    "data-name": "Path 5835",
    d: "M111.869,279.4a.615.615,0,0,0-.3-.361c-1.848-.965-3.938-.745-6.213.654a.618.618,0,0,0,.646,1.053c1.905-1.169,3.539-1.37,4.994-.612a.618.618,0,0,0,.876-.733Z",
    transform: "translate(-105.058 -278.449)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513",
    transform: "translate(15.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5836",
    "data-name": "Path 5836",
    d: "M117.012,279.254a.615.615,0,0,1,.32-.349c1.889-.88,3.967-.566,6.177.932a.619.619,0,0,1-.429,1.125.632.632,0,0,1-.265-.1c-1.85-1.254-3.473-1.529-4.961-.836a.618.618,0,0,1-.842-.771Z",
    transform: "translate(-116.974 -278.418)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514",
    transform: "translate(6.271 15.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5837",
    "data-name": "Path 5837",
    d: "M115.2,292.587a9.726,9.726,0,0,1-5.06-1.291.259.259,0,1,1,.277-.437c2.6,1.645,7.35,1.594,9.417-.1a.259.259,0,0,1,.329.4A8.077,8.077,0,0,1,115.2,292.587Z",
    transform: "translate(-110.018 -290.699)",
    fill: "#eb4d4b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5838",
    "data-name": "Path 5838",
    d: "M115.549,287.571c0,.291-.4.527-.889.527s-.889-.236-.889-.527.4-.526.889-.526S115.549,287.28,115.549,287.571Z",
    transform: "translate(-102.755 -276.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5839",
    "data-name": "Path 5839",
    d: "M116.624,293c0,.4-.721.721-1.612.721S113.4,293.4,113.4,293,116.624,292.6,116.624,293Z",
    transform: "translate(-102.853 -274.643)",
    fill: "#ff7979"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5840",
    "data-name": "Path 5840",
    d: "M111.88,319.753a143.292,143.292,0,0,1-5.776-34.885,24.177,24.177,0,0,0,22-9.325,8.017,8.017,0,0,0,3.206,3.53s6.06-8.856-7.06-17.395c-6.113-3.98-22.834-5.358-30.93,8.292C82.468,288.26,90.112,320.443,111.88,319.753Z",
    transform: "translate(-88.427 -258.946)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5841",
    "data-name": "Path 5841",
    d: "M90.623,380.721s12.783-8.579,5.1-34.022c0,0-8.526,1.376-20.9-7.426,0,0,4.113-22.277,8.794-25.3s17.429-5.775,17.429-5.775,12.4,16.9,21.9,14.425,8.531-16.676,8.531-16.676,10.881,1.4,12.885,3.025c5.666,4.593,7.192,13.8,11.868,16.277,0,0-5.857,5.775-11.868,7.7,0,0,2.424,12.8-3.534,17.6,0,0-5.411,10.919,5.957,28.328C146.781,378.878,124.308,393.016,90.623,380.721Z",
    transform: "translate(-74.816 -246.526)",
    fill: "#4834d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5842",
    "data-name": "Path 5842",
    d: "M132.249,310.759c-.153.844-2.68,1.09-5.644.55s-5.242-1.664-5.087-2.507,2.68-1.09,5.644-.549S132.4,309.916,132.249,310.759Z",
    transform: "translate(-62.477 -245.992)",
    fill: "#fcfffd",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5843",
    "data-name": "Path 5843",
    d: "M97.783,311.065c.2.833-2.522,2.214-6.086,3.085s-6.618.9-6.822.068S87.4,312,90.96,311.132,97.58,310.231,97.783,311.065Z",
    transform: "translate(-72.161 -245.333)",
    fill: "#fcfffd",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(0 74.128)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5844",
    "data-name": "Path 5844",
    d: "M95.719,342.334c7.687,25.443-5.1,34.022-5.1,34.022,33.685,12.295,56.158-1.845,56.158-1.845-11.368-17.408-5.957-28.327-5.957-28.327a9.22,9.22,0,0,0,1.86-2.135c-4.9,1.355-26.657,5.564-36.426.192s-7.51-21.782-7.51-21.782l-3.167,15.375c-9.118,1.33-20.013-6.622-20.013-6.622h0c-.48,2.228-.752,3.7-.752,3.7C87.193,343.71,95.719,342.334,95.719,342.334Z",
    transform: "translate(-74.816 -316.289)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5845",
    "data-name": "Path 5845",
    d: "M130.041,329.873a26,26,0,0,0,6.465-3.331c-5.407,1.346-7.031-5.25-7.514-8.962Z",
    transform: "translate(-60.499 -317.579)",
    fill: "#130f40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5846",
    "data-name": "Path 5846",
    d: "M133.854,355.8c-2.708.455-43.339,3.049-43.339,3.049l2.438-19.36c-3.062-.164-8.948-1.216-16.48-6.062h0s.573,33.7,2.717,36.125,61.917-8.258,61.917-8.258S136.562,355.344,133.854,355.8Z",
    transform: "translate(-74.378 -239.264)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5847",
    "data-name": "Path 5847",
    d: "M84.053,363.895c-1.716-1.7-1.995-15.394-2.761-23.686a57.081,57.081,0,0,0,11.357,1.69l.3-2.411c-3.062-.164-8.948-1.216-16.48-6.062h0s.573,33.7,2.717,36.125,61.917-8.258,61.917-8.258-.474-.618-1.2-1.437C121.387,363.582,85.769,365.6,84.053,363.895Z",
    transform: "translate(-74.378 -239.264)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5848",
    "data-name": "Path 5848",
    d: "M99.2,355.96A26.546,26.546,0,0,1,88.785,369.2c-10.289,6.813-11.691,26.753,12.664,30.558,12.074,1.886,33.384,1.21,45.569-3.617,23.6-9.353,41.871-26.941,41.871-26.941l-2.009-19.639s-35.119,8.674-57.75,9.13S99.2,355.96,99.2,355.96Z",
    transform: "translate(-72.978 -235.001)",
    fill: "#4d32d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M99.2,355.96A26.546,26.546,0,0,1,88.785,369.2c-10.289,6.813-11.691,26.753,12.664,30.558,12.074,1.886,33.384,1.21,45.569-3.617,23.6-9.353,41.871-26.941,41.871-26.941l-2.009-19.639s-35.119,8.674-57.75,9.13S99.2,355.96,99.2,355.96Z",
    transform: "translate(-72.978 -235.001)",
    fill: "#6ab04c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M99.2,355.96A26.546,26.546,0,0,1,88.785,369.2c-10.289,6.813-11.691,26.753,12.664,30.558,12.074,1.886,33.384,1.21,45.569-3.617,23.6-9.353,41.871-26.941,41.871-26.941l-2.009-19.639s-35.119,8.674-57.75,9.13S99.2,355.96,99.2,355.96Z",
    transform: "translate(-72.978 -235.001)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5851",
    "data-name": "Path 5851",
    d: "M74.816,388.8c0-2.626,4.631-1.82,11.826-3.761,0,0,3.065,6.716,25.744,6.716,14.368,0,34.411-12.687,34.411-12.687,19.99-1.042,52.208-8.334,53.718-4.745s-15.272,18.127-36.679,19.32c-38.146,2.125-46.891,14-50.488,14C105.8,407.65,74.816,391.431,74.816,388.8Z",
    transform: "translate(-74.816 -228.715)",
    fill: "#7ed6df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(36.185 81.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5852",
    "data-name": "Path 5852",
    d: "M104.91,368.509l70.528-8.771a1.314,1.314,0,0,0,1-.7l19.222-32.911c.455-.872-2.637-2.539-3.621-2.539l-39.526,2.717a1.31,1.31,0,0,0-1.142.666l-16.1,34.392a1.311,1.311,0,0,1-.972.655l-29.726,3.886a1.31,1.31,0,0,0-1.123,1.517h0A1.309,1.309,0,0,0,104.91,368.509Z",
    transform: "translate(-103.438 -323.592)",
    fill: "#7ed6df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5853",
    "data-name": "Path 5853",
    d: "M106.93,369.691l70.528-8.771a1.314,1.314,0,0,0,1-.7l16.763-33.533a1.31,1.31,0,0,0-1.162-1.917l-39.526,2.716a1.311,1.311,0,0,0-1.142.668l-16.1,34.39a1.307,1.307,0,0,1-.971.656L106.6,367.09a1.31,1.31,0,0,0-1.124,1.516h0A1.312,1.312,0,0,0,106.93,369.691Z",
    transform: "translate(-102.904 -323.28)",
    fill: "#dff9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M158.708,343.5a3.237,3.237,0,1,1-1.522-4.642A3.471,3.471,0,0,1,158.708,343.5Z",
    transform: "translate(-90.48 -319.616)",
    fill: "#7ed6df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519",
    transform: "translate(26.168 108.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M95.57,357.165s2.2-11.307,13.266-12.146,28.579,25.664,56.465,30.274c0,0,.63,7.463-7.589,12.7C157.712,387.989,93.361,378.364,95.57,357.165Z",
    transform: "translate(-95.514 -345)",
    fill: "#6ab04c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5856",
    "data-name": "Path 5856",
    d: "M145.229,381.094s10.593,4.015,15.37,1.072,8.517-10.471,4.154-14.184-4.362,4.8-14.332,2.726Z",
    transform: "translate(-82.377 -339.177)",
    fill: "#4834d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "translate(31.442 112.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5857",
    "data-name": "Path 5857",
    d: "M131.739,378.761s5.086,5.527,3.1,12.6c0,0,58.587-11.94,59.471-33.384.521-12.616-17.38-15.783-39.8,4.642A126.626,126.626,0,0,1,131.739,378.761Z",
    transform: "translate(-91.215 -347.904)",
    fill: "#6ab04c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5858",
    "data-name": "Path 5858",
    d: "M135.083,374.122l-9.943,2.272s.467,6.754.815,6.637,10.93,0,10.93,0A15.006,15.006,0,0,0,135.083,374.122Z",
    transform: "translate(-92.959 -340.975)",
    fill: "#ffc2bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(0 23.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5859",
    "data-name": "Path 5859",
    d: "M136.291,386.381s1.4-5.831-1.63-10.313c0,0-7.453,2.5-12.926,0s-10.945-11.817-18.863-8.673l-2.912,1.979s-2.445,12.926,7.22,20.844C107.182,390.218,126.395,392.208,136.291,386.381Z",
    transform: "translate(-99.686 -366.755)",
    fill: "#4834d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    transform: "translate(0 24.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5860",
    "data-name": "Path 5860",
    d: "M102.6,367.409,99.962,369.2s-2.445,12.926,7.22,20.844c0,0,1.666.171,4.262.265C105.073,385.239,100.979,375.885,102.6,367.409Z",
    transform: "translate(-99.686 -367.409)",
    fill: "#130f40"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5861",
    "data-name": "Path 5861",
    d: "M132.841,325.736c2.517.818,3.29,9.051,1.48,10.229s-26.381,6.578-31.475,2.761-4.492-10.122-2.081-11.29,12.412,2.649,18.061,2.449S129.352,324.6,132.841,325.736Z",
    transform: "translate(-68.435 -241.34)",
    fill: "#fcfffd",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525",
    transform: "translate(94.779)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1754",
    "data-name": "Rectangle 1754",
    width: 76.077,
    height: 100.43,
    fill: "#eb8f15"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1755",
    "data-name": "Rectangle 1755",
    width: 67.872,
    height: 91.338,
    transform: "translate(4.102 4.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1756",
    "data-name": "Rectangle 1756",
    width: 50.638,
    height: 71.467,
    transform: "translate(12.72 14.403)",
    fill: "#fc443e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526",
    transform: "translate(179.243 78.268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1757",
    "data-name": "Rectangle 1757",
    width: 39.882,
    height: 52.648,
    fill: "#eb8f15"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1758",
    "data-name": "Rectangle 1758",
    width: 32.135,
    height: 43.647,
    transform: "translate(3.874 4.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1759",
    "data-name": "Rectangle 1759",
    width: 21.272,
    height: 31.859,
    transform: "translate(9.305 11.45)",
    fill: "#fc443e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2531",
    "data-name": "Group 2531",
    transform: "translate(170.856 184.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2530",
    "data-name": "Group 2530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2527",
    "data-name": "Group 2527",
    transform: "translate(17.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5862",
    "data-name": "Path 5862",
    d: "M236.679,392.482s-13.3-2.174-17.887-8.938,1.46-9.905,1.46-9.905-9.76-4.927-10.485-10.483,4.445-7.972,4.445-7.972-14.737-7.152-5.366-20.389c0,0,13.1-3.914,15.753,8.165,0,0,5.315-4.349,10.63.241s1.6,19.022,1.6,19.022,3.642-4.513,8.3-1.628C250.948,364.193,248.758,382.576,236.679,392.482Z",
    transform: "translate(-205.729 -334.188)",
    fill: "#badc58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5863",
    "data-name": "Path 5863",
    d: "M208.681,335.2S234.6,363.013,235.9,392.213s-5.956,43.655-5.956,43.655",
    transform: "translate(-204.949 -333.92)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5864",
    "data-name": "Path 5864",
    d: "M208.682,346.438l9.936,1.052.806-10.7",
    transform: "translate(-204.949 -333.5)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5865",
    "data-name": "Path 5865",
    d: "M210.158,349.233l10.712,1.439.628-10.828",
    transform: "translate(-204.559 -332.694)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5866",
    "data-name": "Path 5866",
    d: "M212.93,363.61l16.467,2.523,4.981-19.372",
    transform: "translate(-203.826 -330.866)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M215.716,374.24l17.658,5.741,9.012-22.739",
    transform: "translate(-203.09 -328.096)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    "data-name": "Path 5868",
    d: "M216.034,371.41l16.464,4.873,7.307-20.419",
    transform: "translate(-203.006 -328.46)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528",
    transform: "translate(47.359 22.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5869",
    "data-name": "Path 5869",
    d: "M235.321,393.387s13.114-29.116,30.954-41.058c0,0,4.78,8.689.88,14.152s-7.245,4.912-7.245,4.912,6.707,6.2,3.066,14.112-13.214,3.876-13.214,3.876,1.4,3.283-.728,5.271S241.679,398.1,235.321,393.387Z",
    transform: "translate(-227.844 -352.329)",
    fill: "#badc58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M267.1,352.688s-15.012,8.117-30.215,40.6c-7.477,15.976-7.477,45.891-7.477,45.891",
    transform: "translate(-229.407 -352.234)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    y1: 1.45,
    x2: 14.348,
    transform: "translate(24.159 12.334)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    y1: 0.749,
    x2: 13.563,
    transform: "translate(21.617 15.955)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    y1: 2.478,
    x2: 22.531,
    transform: "translate(11.782 29.986)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2529",
    "data-name": "Group 2529",
    transform: "translate(0 28.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    "data-name": "Path 5871",
    d: "M229.435,393.142s-16.887-27.1-36.163-36.555c0,0-3.575,9.249,1.019,14.142s7.837,3.9,7.837,3.9-5.818,7.038-1.153,14.395,13.614,2.076,13.614,2.076-.944,3.44,1.426,5.125S223.762,398.659,229.435,393.142Z",
    transform: "translate(-191.947 -356.587)",
    fill: "#badc58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    "data-name": "Path 5872",
    d: "M193,356.587s20.5,11.075,36.163,36.555c8.189,13.321,10.6,43.968,10.6,43.968",
    transform: "translate(-191.67 -356.587)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    y1: 1.252,
    x2: 10.605,
    transform: "translate(5.428 10.889)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 1.096,
    x2: 18.144,
    transform: "translate(10.118 23.829)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    y1: 1.633,
    x2: 20.804,
    transform: "translate(11.344 28.627)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    y1: 0.835,
    x2: 10.644,
    transform: "translate(26.132 35.412)",
    fill: "none",
    stroke: "#6ab04c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_548",
    "data-name": "Ellipse 548",
    cx: 29.15,
    cy: 4.489,
    rx: 29.15,
    ry: 4.489,
    transform: "translate(18.394 115.61)",
    fill: "#130f40",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1760",
    "data-name": "Rectangle 1760",
    d: "M0,0H44.907a0,0,0,0,1,0,0V29.25a13.8,13.8,0,0,1-13.8,13.8H13.8A13.8,13.8,0,0,1,0,29.25V0A0,0,0,0,1,0,0Z",
    transform: "translate(24.842 75.688)",
    fill: "#eb4d4b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M121.407,271.288c-.927,1.663-5.207,1.042-9.563-1.386s-7.135-5.742-6.209-7.4,5.207-1.042,9.563,1.386S122.332,269.627,121.407,271.288Z",
    transform: "translate(-10.497 -177.262)",
    fill: "#fcfffd",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    transform: "translate(990.487 316.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M463.8,590.089c-4.834-5.718-6.16-10.918-3.943-15.455,7.524-15.391,54.166-21.894,97.65-24.58a2.024,2.024,0,0,1-.272-.759c-22.773,1.4-41.894,3.561-57,6.439C476.821,560.2,463,566.443,459.164,574.3c-2.364,4.837-1,10.318,4.046,16.289,9.683,11.452,30.331,21.115,63.123,29.542,6.583,1.692,13.462,3.282,20.515,4.789q.047-.381.107-.764c-7.025-1.5-13.875-3.086-20.43-4.771C493.892,611,473.374,601.415,463.8,590.089Z",
    transform: "translate(-458.037 -516.321)",
    fill: "#6a97fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M758.98,546.316a2.2,2.2,0,0,1,.1.767c47.048-1.477,118.619-1.1,119.08-1.083l.031-.769C877.728,545.213,806.087,544.835,758.98,546.316Z",
    transform: "translate(-660.367 -513.322)",
    fill: "#6a97fb",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M893.4,842.944c-.76-11.618,7.516-23.023,24.6-33.9,7.08-4.507,10.14-8.546,9.353-12.347-1.138-5.5-10.456-10.206-29.324-14.807-16.838-4.107-39.727-7.773-63.96-11.653-8.587-1.375-17.5-2.8-26.52-4.313-.047.252-.088.505-.131.759,9.022,1.51,17.94,2.939,26.529,4.315,48.451,7.759,90.294,14.461,92.652,25.857.7,3.4-2.328,7.287-9.013,11.542-17.34,11.038-25.736,22.679-24.955,34.6.753,11.485,10.052,21.074,17.721,27.095A108.993,108.993,0,0,0,926.9,880.715l.325-.7C926.9,879.867,894.8,864.422,893.4,842.944Z",
    transform: "translate(-719.736 -658.282)",
    fill: "#6a97fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 264.023, 32.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M56.628,20.58,59.36,0,44.741,10.675,0,33.533l34.607-3.169s17.63-4.283,18.584-5.146A42.905,42.905,0,0,0,56.628,20.58Z",
    transform: "translate(0 0.124)",
    fill: "#c12f56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M71.952,12.427,0,12.953,56.628,0Z",
    transform: "translate(0 20.704)",
    fill: "#ff5b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M33.5,0,52.351,15.144,0,33.657Z",
    transform: "translate(0 0)",
    fill: "#ff5b7e"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M1029.429,925.773s-1.373,13.535-12.053,14.471c10.68.936,12.053,14.471,12.053,14.471s1.373-13.535,12.053-14.471C1030.8,939.308,1029.429,925.773,1029.429,925.773Z",
    transform: "translate(540.176 -444.307)",
    fill: "#02ccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7084",
    "data-name": "Path 7084",
    d: "M1029.429,925.773s-1.373,13.535-12.053,14.471c10.68.936,12.053,14.471,12.053,14.471s1.373-13.535,12.053-14.471C1030.8,939.308,1029.429,925.773,1029.429,925.773Z",
    transform: "translate(-48.836 -475.79)",
    fill: "#02ccc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    d: "M82.164,506.363S80.791,519.9,70.111,520.834c10.68.937,12.053,14.471,12.053,14.471s1.373-13.534,12.053-14.471C83.537,519.9,82.164,506.363,82.164,506.363Z",
    transform: "translate(1158.732 -65.85)",
    fill: "#4aaceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    d: "M206.975,347.052s-1.047,11.992-9.192,12.821c8.145.829,9.192,12.821,9.192,12.821s1.047-11.992,9.192-12.821C208.022,359.044,206.975,347.052,206.975,347.052Z",
    transform: "translate(1065.496 14.179)",
    fill: "#feb546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M206.975,347.052s-1.047,11.992-9.192,12.821c8.145.829,9.192,12.821,9.192,12.821s1.047-11.992,9.192-12.821C208.022,359.044,206.975,347.052,206.975,347.052Z",
    transform: "translate(1264.164 235.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7085",
    "data-name": "Path 7085",
    d: "M206.975,347.052s-1.047,11.992-9.192,12.821c8.145.829,9.192,12.821,9.192,12.821s1.047-11.992,9.192-12.821C208.022,359.044,206.975,347.052,206.975,347.052Z",
    transform: "translate(1498.043 268.808)",
    fill: "#feb546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M209.13,347.052s-1.292,14.91-11.347,15.941c10.055,1.031,11.347,15.941,11.347,15.941s1.292-14.91,11.347-15.941C210.422,361.962,209.13,347.052,209.13,347.052Z",
    transform: "translate(1080.826 331.491)",
    fill: "#fa616e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    transform: "translate(1263.256 491.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282",
    transform: "translate(8.076 8.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M120.76.777,104.308,27.033,87.715,1.054,0,1.789,78.525,127.154,104.98,86.261l26.444,41.475L213.447,0ZM76.132,71.265,49.52,28.865l17.16-.071L85.451,57.376Zm47.278-13.4,18.661-29.379,17.656-.073L132.427,71.4Z",
    fill: "#005ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M34.164,27.879,17.286,57.252,0,26.414,14.889.162Z",
    transform: "translate(106.469 0.61)",
    fill: "#005ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M0,38.992,23.72.006,41.374,28.879l-23.918,40.9Z",
    transform: "translate(60.802 57.369)",
    fill: "#005ea0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    transform: "translate(-0.018 -0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605-2",
    "data-name": "Path 605",
    d: "M120.76.777,104.308,27.033,87.715,1.054,0,1.789,78.525,127.154,104.98,86.261l26.444,41.475L213.447,0ZM76.132,71.265,49.52,28.865l17.16-.071L85.451,57.376Zm47.278-13.4,18.661-29.379,17.656-.073L132.427,71.4Z",
    transform: "translate(0 0.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606-2",
    "data-name": "Path 606",
    d: "M34.167,27.88,17.288,57.256,0,26.418,14.89.163Z",
    transform: "translate(106.723)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607-2",
    "data-name": "Path 607",
    d: "M0,39l23.734-39L41.4,28.891,17.467,69.8Z",
    transform: "translate(62.786 57.864)",
    fill: "url(#pattern-2)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmployeeReg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/employee-reg.c0becdb9.svg";
export { ForwardRef as ReactComponent };